import { render, staticRenderFns } from "./adminBlogs.vue?vue&type=template&id=37da955e"
import script from "./adminBlogs.vue?vue&type=script&lang=js"
export * from "./adminBlogs.vue?vue&type=script&lang=js"
import style0 from "./adminBlogs.vue?vue&type=style&index=0&id=37da955e&prod&lang=css"
import style1 from "./adminBlogs.vue?vue&type=style&index=1&id=37da955e&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports